import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Col, DropdownItem, DropdownMenu, DropdownToggle, Row, UncontrolledDropdown } from 'reactstrap';

import ProgramPlaceholder from './../../../../../../../assets/custom/project-placeholder-img.png';

const PlatformsList = ({ programs, createNew }) => {
  /* ---------------------------- LOCAL STATES ---------------------------- */
  const [searchedName, setSearchedName] = useState('');
  const [allProgramsList, setAllProgramsList] = useState([]);

  /* ---------------------------- DISPATCHING ---------------------------- */
  useEffect(() => {
    if (programs) {
      setAllProgramsList(programs);
    }
  }, [programs]);

  /* ---------------------------- SEARCH PROGRAM BY NAME HANDLER ---------------------------- */
  const searchProgramHandler = e => {
    setSearchedName(e.target.value);

    let filteredProgramsName = programs;
    if (e.target.value.trim() !== '') {
      filteredProgramsName = allProgramsList?.filter(program => program?.name?.toLocaleLowerCase()?.includes(e.target.value?.toLocaleLowerCase()));
    }
    setAllProgramsList([...filteredProgramsName]);
  };

  return (
    <>
      <Row className="g-4 mb-3">
        <Col className="col-sm-auto">
          <div className="btn btn-success" onClick={createNew}>
            <i className="ri-add-line align-bottom me-1"></i> Add New Platform
          </div>
        </Col>
        {/* {allProgramsList?.length > 0 && ( */}
        <Col className="col-sm">
          <div className="d-flex justify-content-sm-end gap-2">
            <div className="search-box ms-2">
              <input type="text" className="form-control" placeholder="Search..." onChange={searchProgramHandler} value={searchedName} />
              <i className="ri-search-line search-icon"></i>
            </div>
          </div>
        </Col>
        {/* )} */}
      </Row>

      <Row>
        <CardHeader className="p-0 border-0 bg-soft-light">
          <Row className="g-0 text-center">
            {allProgramsList?.map((program, key) => (
              <Col xs={6} sm={4} key={key}>
                <div className="p-3 border bg-white border-dashed border-start-0">
                  {/* <h5 className="mb-1"><span className="counter-value" data-target="854">
                                            23
                                        </span>
                                            <span className="text-success ms-1 fs-12">49%<i className="ri-arrow-right-up-line ms-1 align-middle"></i></span>
                                        </h5> */}
                  <p className="text-muted mb-0">{program?.name ?? ''}</p>
                </div>
              </Col>
            ))}
          </Row>
        </CardHeader>
      </Row>
    </>
  );
};

export default PlatformsList;
